export default __webpack_public_path__ + "static/day-1-701243a0fb88a4a6241ced0c0de5ba2b.gif";